import { observer } from 'mobx-react-lite'
import { DocumentManualVerificationModal } from '@/features/jobs/details/components/DocumentManualVerificationModal'
import { type DocumentManualVerificationModalViewModel } from './DocumentManualVerificationModalViewModel'

export interface DocumentManualVerificationModalContainerProps {
  vm: DocumentManualVerificationModalViewModel
}

export const DocumentManualVerificationModalContainer = observer(
  function DocumentManualVerificationModalContainer({
    vm,
  }: DocumentManualVerificationModalContainerProps) {
    return (
      <DocumentManualVerificationModal
        showing={vm.modal.showing}
        onClose={vm.modal.close}
        isMissingProSignature={vm.isMissingProSignature}
        hasViewedDocument={vm.hasViewedDocument}
        onViewDocument={vm.viewDocument}
        onConfirmDocument={vm.confirmDocument}
        onDeleteDocument={vm.deleteDocument}
      />
    )
  },
)
